
import { z } from 'zod';

export const teamEditSchema = z.object({
  name: z.string().min(1, 'Team name is required'),
  club_id: z.string().min(1, 'Club is required'),
  season_id: z.string().min(1, 'Season is required'),
  division_id: z.string().optional(),
  birth_month: z.string().optional(),
  birth_day: z.string().optional(),
  birth_year: z.string().optional(),
});

export type TeamEditFormData = z.infer<typeof teamEditSchema>;
